// src/pages/Games.js   （依你的專案結構調整路徑）
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, onSnapshot, runTransaction } from "firebase/firestore";
import { auth, db } from "../firebase";    // ← 路徑請對應
import "./Games.css";

const gamesList = [
  { name: "Math Adventure", path: "/games/MathAdventure" },
  { name: "Word Wizard",   path: "/games/WordWizard"   },
  { name: "Zhuyin Typing", path: "/games/ChineseTyping"},
  { name: "Space Shooting",path: "/games/PhaserGame"  },
  { name: "Plane Game",    path: "/games/PlaneGame", emoji: "✈️" }
];

export default function Games() {
  const navigate = useNavigate();

  const [userTokens, setUserTokens] = useState(0);
  const [loading,     setLoading]   = useState(true);
  const [showAlert,   setShowAlert] = useState(false);

  /* ①  即時監聽本人 user doc ------------------------------------------------- */
  useEffect(() => {
    const uid = auth.currentUser?.uid;
    if (!uid) {                         // 仍未登入 → 直接顯示 0
      setLoading(false);
      return;
    }

    const unsub = onSnapshot(
      doc(db, "users", uid),
      (snap) => {
        const data = snap.exists() ? snap.data() : {};
        setUserTokens(data.coins ?? 0);
        setLoading(false);
      },
      (err) => {
        console.error("Firestore onSnapshot error:", err);
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  /* ②  點擊遊戲時扣 1 token --------------------------------------------------- */
  const handleGameClick = async (gamePath) => {
    const uid = auth.currentUser?.uid;
    if (!uid) return setShowAlert(true);

    const userRef = doc(db, "users", uid);

    try {
      await runTransaction(db, async (tx) => {
        const snap   = await tx.get(userRef);
        const coins  = snap.data()?.coins ?? 0;
        if (coins <= 0) throw new Error("No tokens");
        tx.update(userRef, { coins: coins - 1 });
      });
      navigate(gamePath);               // 交易成功 → 進入遊戲
    } catch (err) {
      console.error(err);
      setShowAlert(true);               // token 不足或寫入失敗
    }
  };

  /* ③  UI ------------------------------------------------------------------- */
  if (loading) return <div className="games-loading">Loading...</div>;

  return (
    <div className="games-container">
      <h2 className="games-lobby-title">🎮 Game Lobby</h2>
      <p className="games-lobby-description">
        Choose a game below to start learning while having fun!
      </p>

      <div className="games-grid">
        {gamesList.map((game) => (
          <div
            key={game.path}
            className="game-card"
            style={{ cursor: "pointer", opacity: userTokens === 0 ? 0.55 : 1 }}
            onClick={() => handleGameClick(game.path)}
          >
            <div className="game-card-content">
              <div className="game-emoji">{game.emoji || "🕹️"}</div>
              <h3>{game.name}</h3>
              <p>Click to play!</p>
            </div>
          </div>
        ))}
      </div>

      {/* Token display */}
      <div style={{ marginTop: 16, color: "#2196f3", fontWeight: "bold" }}>
        Available Tokens: {userTokens}
      </div>

      {/* Alert modal */}
      {showAlert && (
        <div className="games-alert-modal">
          <div className="games-alert-content">
            <h4>No tokens left</h4>
            <p>
              You need at least 1&nbsp;token to play a game.<br />
              Go complete more practices to earn more tokens!
            </p>
            <button onClick={() => setShowAlert(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
}
